module.exports = __webpack_public_path__ + "static/media/jupiter.c25c0f66.png";